import React, { useState } from 'react';
import PageHeader from '../components/layout/PageHeader';
import Button from '../components/ui/Button';
import { CheckCircleIcon } from 'lucide-react';
const AlumniJoin = () => {
  const [formStep, setFormStep] = useState(1);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real application, this would submit the form data to a server
    setFormSubmitted(true);
  };
  const nextStep = () => {
    setFormStep(formStep + 1);
  };
  const prevStep = () => {
    setFormStep(formStep - 1);
  };
  return <div className="min-h-screen bg-white" data-id="element-2497">
      <PageHeader title="Join the Alumni Association" description="Connect with fellow alumni, stay updated with school news, and contribute to the growth of your alma mater." backgroundImage="https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Alumni',
      path: '/alumni'
    }, {
      label: 'Join',
      path: '/alumni/join'
    }]} data-id="element-2498" />
      <div className="container mx-auto px-4 py-12" data-id="element-2499">
        <div className="text-center mb-10" data-id="element-2500">
          <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-2501">
            Alumni Association Membership
          </h2>
          <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-2502"></div>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-2503">
            Join a network of over 15,000 IGS alumni worldwide. Membership in
            the Alumni Association provides numerous benefits and opportunities
            to give back to your alma mater.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16" data-id="element-2504">
          <div className="lg:col-span-2 bg-white p-6 rounded-lg shadow-md" data-id="element-2505">
            {formSubmitted ? <div className="text-center py-12" data-id="element-2506">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-6" data-id="element-2507">
                  <CheckCircleIcon className="h-10 w-10 text-green-600" data-id="element-2508" />
                </div>
                <h3 className="text-2xl font-bold text-blue-900 mb-3" data-id="element-2509">
                  Registration Successful!
                </h3>
                <p className="text-gray-700 mb-6 max-w-lg mx-auto" data-id="element-2510">
                  Thank you for joining the Isonyin Grammar School Alumni
                  Association. Your application has been received and is being
                  processed.
                </p>
                <p className="text-gray-700 mb-8 max-w-lg mx-auto" data-id="element-2511">
                  You will receive a confirmation email shortly with further
                  instructions on how to complete your membership process.
                </p>
                <Button href="/alumni" variant="primary" data-id="element-2512">
                  Return to Alumni Page
                </Button>
              </div> : <>
                <div className="mb-8" data-id="element-2513">
                  <div className="flex items-center justify-between mb-4" data-id="element-2514">
                    <div className="flex items-center" data-id="element-2515">
                      <div className={`flex items-center justify-center w-8 h-8 rounded-full ${formStep >= 1 ? 'bg-blue-900 text-white' : 'bg-gray-200 text-gray-500'} mr-2`} data-id="element-2516">
                        1
                      </div>
                      <span className={`font-medium ${formStep >= 1 ? 'text-blue-900' : 'text-gray-500'}`} data-id="element-2517">
                        Personal Information
                      </span>
                    </div>
                    <div className="flex-1 h-1 mx-4 bg-gray-200" data-id="element-2518">
                      <div className={`h-1 bg-blue-900 ${formStep >= 2 ? 'w-full' : 'w-0'} transition-all duration-300`} data-id="element-2519"></div>
                    </div>
                    <div className="flex items-center" data-id="element-2520">
                      <div className={`flex items-center justify-center w-8 h-8 rounded-full ${formStep >= 2 ? 'bg-blue-900 text-white' : 'bg-gray-200 text-gray-500'} mr-2`} data-id="element-2521">
                        2
                      </div>
                      <span className={`font-medium ${formStep >= 2 ? 'text-blue-900' : 'text-gray-500'}`} data-id="element-2522">
                        Education & Career
                      </span>
                    </div>
                    <div className="flex-1 h-1 mx-4 bg-gray-200" data-id="element-2523">
                      <div className={`h-1 bg-blue-900 ${formStep >= 3 ? 'w-full' : 'w-0'} transition-all duration-300`} data-id="element-2524"></div>
                    </div>
                    <div className="flex items-center" data-id="element-2525">
                      <div className={`flex items-center justify-center w-8 h-8 rounded-full ${formStep >= 3 ? 'bg-blue-900 text-white' : 'bg-gray-200 text-gray-500'} mr-2`} data-id="element-2526">
                        3
                      </div>
                      <span className={`font-medium ${formStep >= 3 ? 'text-blue-900' : 'text-gray-500'}`} data-id="element-2527">
                        Membership
                      </span>
                    </div>
                  </div>
                </div>
                <form onSubmit={handleSubmit} data-id="element-2528">
                  {formStep === 1 && <div className="space-y-4 animate-fadeIn" data-id="element-2529">
                      <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-2530">
                        Personal Information
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2531">
                        <div data-id="element-2532">
                          <label htmlFor="firstName" className="block text-gray-700 font-medium mb-1" data-id="element-2533">
                            First Name
                          </label>
                          <input type="text" id="firstName" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-2534" />
                        </div>
                        <div data-id="element-2535">
                          <label htmlFor="lastName" className="block text-gray-700 font-medium mb-1" data-id="element-2536">
                            Last Name
                          </label>
                          <input type="text" id="lastName" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-2537" />
                        </div>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2538">
                        <div data-id="element-2539">
                          <label htmlFor="email" className="block text-gray-700 font-medium mb-1" data-id="element-2540">
                            Email Address
                          </label>
                          <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-2541" />
                        </div>
                        <div data-id="element-2542">
                          <label htmlFor="phone" className="block text-gray-700 font-medium mb-1" data-id="element-2543">
                            Phone Number
                          </label>
                          <input type="tel" id="phone" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-2544" />
                        </div>
                      </div>
                      <div data-id="element-2545">
                        <label htmlFor="address" className="block text-gray-700 font-medium mb-1" data-id="element-2546">
                          Current Address
                        </label>
                        <textarea id="address" rows={3} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-2547"></textarea>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-2548">
                        <div data-id="element-2549">
                          <label htmlFor="city" className="block text-gray-700 font-medium mb-1" data-id="element-2550">
                            City
                          </label>
                          <input type="text" id="city" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-2551" />
                        </div>
                        <div data-id="element-2552">
                          <label htmlFor="state" className="block text-gray-700 font-medium mb-1" data-id="element-2553">
                            State
                          </label>
                          <input type="text" id="state" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-2554" />
                        </div>
                        <div data-id="element-2555">
                          <label htmlFor="country" className="block text-gray-700 font-medium mb-1" data-id="element-2556">
                            Country
                          </label>
                          <input type="text" id="country" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-2557" />
                        </div>
                      </div>
                      <div className="flex justify-end mt-6" data-id="element-2558">
                        <Button type="button" onClick={nextStep} variant="primary" data-id="element-2559">
                          Next: Education & Career
                        </Button>
                      </div>
                    </div>}
                  {formStep === 2 && <div className="space-y-4 animate-fadeIn" data-id="element-2560">
                      <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-2561">
                        Education & Career Information
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2562">
                        <div data-id="element-2563">
                          <label htmlFor="graduationYear" className="block text-gray-700 font-medium mb-1" data-id="element-2564">
                            Year of Graduation from IGS
                          </label>
                          <input type="number" id="graduationYear" min="1967" max="2023" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-2565" />
                        </div>
                        <div data-id="element-2566">
                          <label htmlFor="set" className="block text-gray-700 font-medium mb-1" data-id="element-2567">
                            Set/Class
                          </label>
                          <input type="text" id="set" placeholder="e.g., 1990/1996 Set" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-2568" />
                        </div>
                      </div>
                      <div data-id="element-2569">
                        <label htmlFor="education" className="block text-gray-700 font-medium mb-1" data-id="element-2570">
                          Highest Educational Qualification
                        </label>
                        <select id="education" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-2571">
                          <option value="" data-id="element-2572">Select qualification</option>
                          <option value="Secondary School" data-id="element-2573">
                            Secondary School
                          </option>
                          <option value="Diploma" data-id="element-2574">Diploma/Certificate</option>
                          <option value="Bachelor" data-id="element-2575">Bachelor's Degree</option>
                          <option value="Master" data-id="element-2576">Master's Degree</option>
                          <option value="Doctorate" data-id="element-2577">Doctorate</option>
                          <option value="Other" data-id="element-2578">Other</option>
                        </select>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2579">
                        <div data-id="element-2580">
                          <label htmlFor="profession" className="block text-gray-700 font-medium mb-1" data-id="element-2581">
                            Current Profession
                          </label>
                          <input type="text" id="profession" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-2582" />
                        </div>
                        <div data-id="element-2583">
                          <label htmlFor="company" className="block text-gray-700 font-medium mb-1" data-id="element-2584">
                            Company/Organization
                          </label>
                          <input type="text" id="company" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-2585" />
                        </div>
                      </div>
                      <div data-id="element-2586">
                        <label htmlFor="bio" className="block text-gray-700 font-medium mb-1" data-id="element-2587">
                          Brief Bio/Profile
                        </label>
                        <textarea id="bio" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Share a brief summary of your professional journey, achievements, and interests." data-id="element-2588"></textarea>
                      </div>
                      <div className="flex justify-between mt-6" data-id="element-2589">
                        <Button type="button" onClick={prevStep} variant="outline" data-id="element-2590">
                          Back
                        </Button>
                        <Button type="button" onClick={nextStep} variant="primary" data-id="element-2591">
                          Next: Membership Options
                        </Button>
                      </div>
                    </div>}
                  {formStep === 3 && <div className="space-y-4 animate-fadeIn" data-id="element-2592">
                      <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-2593">
                        Membership Options
                      </h3>
                      <div className="bg-blue-50 p-4 rounded-lg border border-blue-100 mb-6" data-id="element-2594">
                        <h4 className="font-bold text-blue-900 mb-2" data-id="element-2595">
                          Membership Types
                        </h4>
                        <div className="space-y-3" data-id="element-2596">
                          <div className="flex items-start" data-id="element-2597">
                            <input type="radio" id="regular" name="membershipType" value="regular" className="mt-1" defaultChecked data-id="element-2598" />
                            <label htmlFor="regular" className="ml-2" data-id="element-2599">
                              <div className="font-medium text-blue-900" data-id="element-2600">
                                Regular Membership - ₦5,000/year
                              </div>
                              <div className="text-sm text-gray-600" data-id="element-2601">
                                Basic membership with access to alumni network
                                and events.
                              </div>
                            </label>
                          </div>
                          <div className="flex items-start" data-id="element-2602">
                            <input type="radio" id="premium" name="membershipType" value="premium" className="mt-1" data-id="element-2603" />
                            <label htmlFor="premium" className="ml-2" data-id="element-2604">
                              <div className="font-medium text-blue-900" data-id="element-2605">
                                Premium Membership - ₦15,000/year
                              </div>
                              <div className="text-sm text-gray-600" data-id="element-2606">
                                Enhanced benefits including exclusive events and
                                mentoring opportunities.
                              </div>
                            </label>
                          </div>
                          <div className="flex items-start" data-id="element-2607">
                            <input type="radio" id="lifetime" name="membershipType" value="lifetime" className="mt-1" data-id="element-2608" />
                            <label htmlFor="lifetime" className="ml-2" data-id="element-2609">
                              <div className="font-medium text-blue-900" data-id="element-2610">
                                Lifetime Membership - ₦100,000
                              </div>
                              <div className="text-sm text-gray-600" data-id="element-2611">
                                One-time payment for lifetime membership with
                                all premium benefits.
                              </div>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div data-id="element-2612">
                        <label className="block text-gray-700 font-medium mb-2" data-id="element-2613">
                          Areas of Interest (Select all that apply)
                        </label>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-2614">
                          <div className="flex items-center" data-id="element-2615">
                            <input type="checkbox" id="mentoring" className="mr-2" data-id="element-2616" />
                            <label htmlFor="mentoring" data-id="element-2617">
                              Mentoring Current Students
                            </label>
                          </div>
                          <div className="flex items-center" data-id="element-2618">
                            <input type="checkbox" id="fundraising" className="mr-2" data-id="element-2619" />
                            <label htmlFor="fundraising" data-id="element-2620">
                              Fundraising & Development
                            </label>
                          </div>
                          <div className="flex items-center" data-id="element-2621">
                            <input type="checkbox" id="events" className="mr-2" data-id="element-2622" />
                            <label htmlFor="events" data-id="element-2623">
                              Event Planning & Organization
                            </label>
                          </div>
                          <div className="flex items-center" data-id="element-2624">
                            <input type="checkbox" id="networking" className="mr-2" data-id="element-2625" />
                            <label htmlFor="networking" data-id="element-2626">
                              Professional Networking
                            </label>
                          </div>
                          <div className="flex items-center" data-id="element-2627">
                            <input type="checkbox" id="scholarship" className="mr-2" data-id="element-2628" />
                            <label htmlFor="scholarship" data-id="element-2629">
                              Scholarship Programs
                            </label>
                          </div>
                          <div className="flex items-center" data-id="element-2630">
                            <input type="checkbox" id="reunion" className="mr-2" data-id="element-2631" />
                            <label htmlFor="reunion" data-id="element-2632">Class Reunions</label>
                          </div>
                        </div>
                      </div>
                      <div data-id="element-2633">
                        <label htmlFor="comments" className="block text-gray-700 font-medium mb-1" data-id="element-2634">
                          Additional Comments
                        </label>
                        <textarea id="comments" rows={3} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Any other information you'd like to share with us" data-id="element-2635"></textarea>
                      </div>
                      <div className="flex items-start mt-4" data-id="element-2636">
                        <input type="checkbox" id="terms" className="mt-1" required data-id="element-2637" />
                        <label htmlFor="terms" className="ml-2 text-sm text-gray-700" data-id="element-2638">
                          I agree to the{' '}
                          <a href="/terms-of-use" className="text-blue-700 hover:underline" data-id="element-2639">
                            Terms of Use
                          </a>{' '}
                          and{' '}
                          <a href="/privacy-policy" className="text-blue-700 hover:underline" data-id="element-2640">
                            Privacy Policy
                          </a>
                          . I confirm that all information provided is accurate.
                        </label>
                      </div>
                      <div className="flex justify-between mt-6" data-id="element-2641">
                        <Button type="button" onClick={prevStep} variant="outline" data-id="element-2642">
                          Back
                        </Button>
                        <Button type="submit" variant="primary" data-id="element-2643">
                          Submit Application
                        </Button>
                      </div>
                    </div>}
                </form>
              </>}
          </div>
          <div data-id="element-2644">
            <div className="bg-blue-900 text-white p-6 rounded-lg shadow-md mb-6" data-id="element-2645">
              <h3 className="text-xl font-bold mb-4" data-id="element-2646">Membership Benefits</h3>
              <ul className="space-y-3" data-id="element-2647">
                <li className="flex items-start" data-id="element-2648">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-2649">
                    ✓
                  </div>
                  <p data-id="element-2650">Access to alumni networking platform</p>
                </li>
                <li className="flex items-start" data-id="element-2651">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-2652">
                    ✓
                  </div>
                  <p data-id="element-2653">Invitations to alumni events and reunions</p>
                </li>
                <li className="flex items-start" data-id="element-2654">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-2655">
                    ✓
                  </div>
                  <p data-id="element-2656">Regular newsletters and updates</p>
                </li>
                <li className="flex items-start" data-id="element-2657">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-2658">
                    ✓
                  </div>
                  <p data-id="element-2659">Career development opportunities</p>
                </li>
                <li className="flex items-start" data-id="element-2660">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-2661">
                    ✓
                  </div>
                  <p data-id="element-2662">Mentorship programs</p>
                </li>
                <li className="flex items-start" data-id="element-2663">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-2664">
                    ✓
                  </div>
                  <p data-id="element-2665">Alumni directory access</p>
                </li>
                <li className="flex items-start" data-id="element-2666">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-2667">
                    ✓
                  </div>
                  <p data-id="element-2668">Opportunities to give back to IGS</p>
                </li>
              </ul>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-2669">
              <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-2670">
                Contact Information
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-2671">
                If you have any questions about alumni membership or need
                assistance with the registration process, please contact:
              </p>
              <div className="space-y-2 text-gray-700" data-id="element-2672">
                <p data-id="element-2673">
                  <strong data-id="element-2674">Alumni Relations Office</strong>
                </p>
                <p data-id="element-2675">Email: alumni@isonyingrammarschool.edu.ng</p>
                <p data-id="element-2676">Phone: +234 (0) 803 456 7890</p>
                <p data-id="element-2677">Office Hours: Monday-Friday, 9:00 AM - 4:00 PM</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default AlumniJoin;